import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
function parseQuery() {
    if (typeof window === 'undefined')
        return null;
    const q = new URLSearchParams(window.location.search);
    const raw = q.get('payment');
    if (raw !== 'success' && raw !== 'fail')
        return null;
    const prov = q.get('provider');
    const provider = prov === 'unitpay' || prov === 'tinkoff' || prov === 'paddle' ? prov : null;
    return { status: raw, provider };
}
function clearQuery() {
    const url = new URL(window.location.href);
    url.searchParams.delete('payment');
    url.searchParams.delete('provider');
    url.searchParams.delete('unitpay_orderId');
    url.searchParams.delete('unitpayId');
    window.history.replaceState({}, '', url.pathname + (url.search ? `?${url.searchParams}` : '') + url.hash);
}
export function PaymentResultBanner() {
    const { t } = useTranslation();
    const [result, setResult] = useState(null);
    useEffect(() => {
        const parsed = parseQuery();
        if (parsed) {
            setResult(parsed);
            clearQuery();
        }
    }, []);
    if (!result)
        return null;
    const ok = result.status === 'success';
    const title = ok ? t('payResult.okTitle', 'Оплата прошла!') : t('payResult.failTitle', 'Оплата не прошла');
    const body = ok ? (_jsxs(_Fragment, { children: [t('payResult.okBody1', 'Спасибо! Подписка активируется автоматически — обычно за 10–30 секунд. Откроется в боте '), _jsx("a", { href: "https://t.me/scenixart_bot", style: { color: '#7e69ff', textDecoration: 'underline' }, children: "@scenixart_bot" }), t('payResult.okBody2', ' или на этом сайте.')] })) : (_jsxs(_Fragment, { children: [t('payResult.failBody1', 'Платёж не был завершён или отклонён банком. Деньги не списаны. Можно попробовать ещё раз или написать в '), _jsx("a", { href: "https://t.me/scenixart_bot", style: { color: '#7e69ff', textDecoration: 'underline' }, children: t('payResult.support', 'поддержку') }), "."] }));
    const onClose = () => setResult(null);
    return (_jsx("div", { onClick: onClose, role: "dialog", "aria-modal": "true", "aria-label": title, style: {
            position: 'fixed', inset: 0, zIndex: 10000,
            background: 'rgba(0,0,0,.65)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: 16, backdropFilter: 'blur(2px)',
        }, children: _jsxs("div", { onClick: (e) => e.stopPropagation(), style: {
                width: '100%', maxWidth: 420,
                background: 'linear-gradient(180deg, #1a1530 0%, #15101f 100%)',
                color: '#fff',
                borderRadius: 16,
                padding: '28px 24px 22px',
                border: `1px solid ${ok ? 'rgba(78, 220, 130, .35)' : 'rgba(255, 90, 90, .35)'}`,
                boxShadow: '0 20px 60px rgba(0,0,0,.5)',
                textAlign: 'center',
            }, children: [_jsx("div", { style: {
                        width: 56, height: 56, borderRadius: '50%', margin: '0 auto 14px',
                        background: ok ? 'rgba(78,220,130,.18)' : 'rgba(255,90,90,.18)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 30, lineHeight: 1,
                    }, "aria-hidden": true, children: ok ? '✓' : '×' }), _jsx("div", { style: { fontSize: 20, fontWeight: 700, marginBottom: 8 }, children: title }), _jsx("div", { style: { fontSize: 14, lineHeight: 1.55, opacity: 0.85, marginBottom: 20 }, children: body }), _jsx("button", { type: "button", onClick: onClose, style: {
                        width: '100%', padding: '12px 16px', borderRadius: 10, border: 'none', cursor: 'pointer',
                        background: ok ? '#7e69ff' : 'rgba(255,255,255,.10)',
                        color: '#fff', fontSize: 15, fontWeight: 600,
                    }, children: ok ? t('payResult.ok', 'Понятно') : t('payResult.close', 'Закрыть') })] }) }));
}
